
import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  font-size: 18px;
  border-width: 5px;
  border-radius: 10px;
  background-color: lightblue;
`;

const TableContainer = styled.div`
  border: 1px solid #ccc;
  border-collapse: separate;
  border-spacing: 3px;
  border-radius: 10px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const TableWrapper = styled.div`
  height: 70vh;
  overflow-y: auto;
  flex: 1;
  min-width: 300px;
  width: 100%;
  margin-bottom: 10px;
`;

const Label = styled.label`
  margin-bottom: 5px;
  margin-left: 8px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 200px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid DarkGray;

  th, td {
    border-left: none;
    border-right: none;
    border-bottom: 1px solid DarkGray;
    border-top: 1px solid DarkGray;
    padding: 6px;
    text-align: left;
  }

  tr {
    background-color: LightGreen;
  }

  th {
    background-color: #f2f2f2;
    cursor: pointer;

    &:hover {
      background-color: #e0e0e0;
      color: #007bff;
      transition: background-color 0.3s ease, color 0.3s ease;
    }
  }
`;

const DellQuoteCompare = () => {

const sortTable = (n, tableId) => {
  const table = document.getElementById(tableId);
  let switching = true;
  let dir = 'asc';
  let switchcount = 0;

  while (switching) {
    switching = false;
    const rows = table.rows;

    for (let i = 1; i < rows.length - 1; i++) {
      const x = rows[i].getElementsByTagName('TD')[n];
      const y = rows[i + 1].getElementsByTagName('TD')[n];

      const shouldSwitch =
        (dir === 'asc' && x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) ||
        (dir === 'desc' && x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase());

      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        switchcount++;
        break; // Break to restart the loop after switching
      }
    }

    if (!switching && switchcount === 0 && dir === 'asc') {
      dir = 'desc';
      switching = true;
    }
  }
};

  return (
    <div>
      <h2 style={{ textAlign: 'left' }}>Dell Quote Compare</h2>
      <TableContainer>
        {/* First Quote */}
        <div style={{ width: '49%' }}>
          <Label htmlFor="Quote1">First Quote #</Label>
          <Input type="text" id="Quote1" name="Quote1" placeholder="Quote#.Ver#" />
          <TableWrapper>
            <StyledTable id="myTable">
              <thead>
                <tr>
                  <th onClick={() => sortTable(0, 'myTable')}>Column 1</th>
                  <th onClick={() => sortTable(1, 'myTable')}>Column 2</th>
                  <th onClick={() => sortTable(2, 'myTable')}>Column 3</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ backgroundColor: 'LightCoral' }}><td>a Row 1</td><td>z</td><td>Long text</td></tr>
                <tr><td>b Row 2, Col 1</td><td>y Row 2, Col 2</td><td>Row 2, Col 3</td></tr>
                <tr><td>c Row 3, Col 1</td><td>x Row 3, Col 2</td><td>Row 3, Col 3</td></tr>
                <tr><td>d Row 4, Col 1</td><td>w Row 4, Col 2</td><td>Row 4, Col 3</td></tr>
                <tr><td>e Row 5, Col 1</td><td>v Row 5, Col 2</td><td>Row 5, Col 3</td></tr>
                <tr><td>f Row 6, Col 1</td><td>u Row 6, Col 2</td><td>Row 6, Col 3</td></tr>
                <tr><td>g Row 7, Col 1</td><td>vRow 7, Col 2</td><td>Row 7, Col 3</td></tr>
                <tr><td>h Row 8, Col 1</td><td>t Row 8, Col 2</td><td>Row 8, Col 3</td></tr>
                <tr><td>i Row 9, Col 1</td><td>r Row 9, Col 2</td><td>Row 9, Col 3</td></tr>
                <tr><td>j Row 10, Col 1</td><td>s Row 10, Col 2</td><td>Row 10, Col 3</td></tr>
              </tbody>
            </StyledTable>
          </TableWrapper>
          <Button onClick={() => alert('Button clicked!')}>Save #1</Button>
        </div>

        {/* Second Quote */}
        <div style={{ width: '49%' }}>
          <Label htmlFor="Quote2">Second Quote #</Label>
          <Input type="text" id="Quote2" name="Quote2" placeholder="Quote#.Ver#" />
          <TableWrapper>
            <StyledTable id="myTable2">
              <thead>
                <tr>
                  <th onClick={() => sortTable(0, 'myTable2')}>Section 2-1</th>
                  <th onClick={() => sortTable(1, 'myTable2')}>Section 2-2</th>
                  <th onClick={() => sortTable(2, 'myTable2')}>Section 2-3</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ backgroundColor: 'LightCoral' }}><td>a Row 1</td><td>z</td><td>Text</td></tr>
                <tr><td>b Row 2, Col 1</td><td>y Row 2, Col 2</td><td>Row 2, Col 3</td></tr>
                <tr><td>c Row 3, Col 1</td><td>x Row 3, Col 2</td><td>Row 3, Col 3</td></tr>
                <tr><td>d Row 4, Col 1</td><td>w Row 4, Col 2</td><td>Row 4, Col 3</td></tr>
                <tr><td>e Row 5, Col 1</td><td>v Row 5, Col 2</td><td>Row 5, Col 3</td></tr>
                <tr><td>f Row 6, Col 1</td><td>u Row 6, Col 2</td><td>Row 6, Col 3</td></tr>
                <tr><td>g Row 7, Col 1</td><td>vRow 7, Col 2</td><td>Row 7, Col 3</td></tr>
                <tr><td>h Row 8, Col 1</td><td>t Row 8, Col 2</td><td>Row 8, Col 3</td></tr>
                <tr><td>i Row 9, Col 1</td><td>s Row 9, Col 2</td><td>Row 9, Col 3</td></tr>
                <tr><td>j Row 10, Col 1</td><td>r Row 10, Col 2</td><td>Row 10, Col 3</td></tr>
                <tr style={{whiteSpace: 'nowrap'}}><td>k Row 11, Col 1</td><td>q Row 11, Col 2</td><td>Row 11, Col 3</td></tr>
                <tr><td>l Row 12, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td>l Row 13, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td>l Row 14, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td>l Row 15, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td>l Row 16, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr style={{whiteSpace: 'nowrap'}}><td>l Row 17, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td>l Row 18, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td>l Row 19, Col 1</td><td>p Row 12, Col 2</td><td>Row 12, Col 3</td></tr>
                <tr><td style={{whiteSpace: 'nowrap'}}>l Row 20, Col 1</td><td style={{whiteSpace: 'nowrap'}}>p Row 12, Col 2</td><td>This is description of processor that is really long and keeps going longer</td></tr>
              </tbody>
            </StyledTable>
          </TableWrapper>
          <Button onClick={() => alert('Button clicked!')}>Save #2</Button>
        </div>
      </TableContainer>
    </div>
  );
};

export default DellQuoteCompare;
